module.exports = __webpack_public_path__ + "static/media/YB5M17_1.a7db80fa.jpg";